"use strict";

exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.4.11@element-ui/lib/mixins/focus.js
// module id = 43
// module chunks = 0